module.exports = __webpack_public_path__ + "img/enable_mail_hdtool.e818abd0.png";